
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/DodaFront/View/JobContent/JobTrend",
      function () {
        return require("private-next-pages/DodaFront/View/JobContent/JobTrend/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/DodaFront/View/JobContent/JobTrend"])
      });
    }
  